import React from 'react';
import { MetricUId } from '../../Metrics/constants';
import WidgetBodyWrapper from '../WidgetBodyWrapper';
import { getMetricDataFromArray } from '../../Metrics/utils';
import ChrMetric from '../../../generic/PageUI/Compound/Metric/ChrMetric';
import getChartConfig from './utils';
import StackedBarChart from '../../Reports/templates/StackedBarChart';

const Body = (props) => {
  const { metrics } = props;
  const neverConnectedMenteesOneTime = getMetricDataFromArray(metrics, MetricUId.NEVER_CONNECTED_MENTEES_ONE_TIME);
  const menteesWhoSentMeetingRequestButNeverConnectedOneTime = getMetricDataFromArray(metrics, MetricUId.MENTEES_WHO_SENT_MEETING_REQUEST_BUT_NEVER_CONNECTED_ONE_TIME);
  const menteesWhoHaventSentMeetingRequestAndNeverConnected = getMetricDataFromArray(metrics, MetricUId.MENTEES_WHO_HAVENT_SENT_MEETING_REQUEST_AND_NEVER_CONNECTED_ONE_TIME);
  const dataAvailable = neverConnectedMenteesOneTime.data.value > 0;
  const getOptionsForMarker = colorName => ({ show: dataAvailable, className: `cui-management-report-temp-chart-${colorName}` });

  return (
    <WidgetBodyWrapper {...props} >
      <div className='d-flex flex-column'>
        <ChrMetric {...neverConnectedMenteesOneTime} />
        <div className='cui-border-gray border-radius-0-5-important px-3 py-3 mt-3 d-flex flex-column'>
          { dataAvailable &&
            <div>
              <div className='px-1 font-12 font-600'>
                { neverConnectedMenteesOneTime.breakdownText }
              </div>
              <StackedBarChart chartOptions={getChartConfig({ metrics })} />
            </div>
          }
          <WidgetBodyWrapper {...props} wrapperPadding="py-3 px-1" >
            <ChrMetric {...menteesWhoSentMeetingRequestButNeverConnectedOneTime} marker={getOptionsForMarker("blue")} />
            <ChrMetric {...menteesWhoHaventSentMeetingRequestAndNeverConnected} marker={getOptionsForMarker("red")} />
          </WidgetBodyWrapper>
        </div>
      </div>
    </WidgetBodyWrapper>
  );
};

export default Body;
